import React from 'react';
import styles from './vertical-progress-bar.css';
import { generateColor } from './helpers';
import { Colors } from '../colors';
import classNames from 'classnames';

interface Props {
  /** Bottom of the range (x) of y */
  current?: number;
  /** Top of the range x of (y) */
  max?: number;
  /** Precalculated percentage (override regular calculation) */
  percentage?: number;
  /** Set to false to prevent color changing when it reaches certain thresholds */
  warn?: boolean;
  /** Set color change thresholds. Example {'40': Colors.Orange,'60': Colors.RadicalRed} will turn orange at 40% and red at 60% */
  warnOptions?: {
    [e: string]: Colors;
  };
  /** This is the progress color. Set "Warn" to false to prevent colors from changing at the top of the range. */
  color?: Colors;
  /** This is empty space color (remaining). */
  negativeColor?: Colors;
  /** Meter always shows at least 15% at the bottom. Allow empty allows the bar to show less than 15%. */
  allowEmpty?: boolean;
  /** Extra props to throw on the meter */
  meterProps?: { style?: React.CSSProperties; className?: string; [arg: string]: any };
  /** className on the wrapper */
  className?: string;
  /** Component width */
  width?: number;
  /** rest */
  [arg: string]: any;
}

const VerticalProgressBar = ({
  max = 100,
  current = 0,
  percentage = (current / max) * 100,
  color = Colors.UnbounceBlue,
  negativeColor = Colors.Emperor,
  warn = true,
  width = 12,
  allowEmpty = false,
  warnOptions = {
    '75': Colors.Orange,
    '90': Colors.RadicalRed
  },
  meterProps: { style: meterStyle = {}, className: meterClassName = '', ...meterRest } = {},
  className,
  ...rest
}: Props) => (
  <div
    className={classNames([styles.wrapper, className])}
    style={{
      background: `var(--${negativeColor})`,
      width,
      borderRadius: width,
      ...(rest.style ? rest.style : null)
    }}
    {...rest}
  >
    <div
      className={classNames([styles.meter, meterClassName])}
      style={{
        height: `${percentage < 15 && !allowEmpty ? 15 : percentage}%`,
        background: generateColor({ warn, warnOptions, color, percentage }),
        borderRadius: width,
        ...meterStyle
      }}
      {...meterRest}
    />
  </div>
);

export default VerticalProgressBar;
